import styled from 'styled-components';


export const PlaceholderWrapper = styled.div`
  position: relative;
  min-height: ${({ theme }) => theme.spacing(900)};
`;

const HomepageHeroCarouselComponent = styled.div`
  contain: layout paint;
  contain-intrinsic-size: 1000px;
  position: relative;
  min-height: calc(50vw + 380px);
  overflow: hidden;
  background-color: ${({ theme }) => theme.colours.yellow};
  &.bushs-beans-foodservices {
    min-height: 600px !important;
    @media (min-width: 768px) {
      min-height: 800px !important;
    }
  }
  @media (min-width: 768px) {
    min-height: calc(60vw + 380px);
  }
  @media (min-width: 1200px) {
    min-height: 59vw;
  }

  @media (max-width: 1300px) {
    contain-intrinsic-size: 650px;
  }
  @media (max-width: 500px) {
    contain-intrinsic-size: 500px;
  }
  & .tagline {
    position: relative;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    background-color: ${({ theme }) => theme.colours.red};

    .tagline-wrap {
      padding-right: ${({ theme }) => theme.spacing(20)};
      padding-left: ${({ theme }) => theme.spacing(20)};
      padding-bottom: 15px;
      padding-top: 20px;
      white-space: nowrap;
      overflow: visible;
      @media (min-width: 1200px) {
        padding-right: ${({ theme }) => theme.spacing(120)};
        padding-left: ${({ theme }) => theme.spacing(120)};
      }

      @media (min-width: ${({ theme }) => theme.breakPoints.tablet}) {
        padding-right: ${({ theme }) => theme.spacing(55)};
        padding-left: ${({ theme }) => theme.spacing(55)};
      }
      img {
        display: none;
      }
    }
    & h1 {
      color: ${({ theme }) => theme.colours.yellow};
      display: block;
      text-align: center;
      margin-bottom: 0;
      width: 100%;
      font-size: 7.5vw;
      line-height: 1;
      font-style: normal;
      font-weight: 500 !important;
      font-family: 'apercu pro';
      .span {
        text-decoration: underline;
      }
    }
    & img {
      width: 100%;
      height: auto;
      margin: ${({ theme }) => theme.spacing(8, 'auto')};
      display: none;
      ${({ theme }) => theme.breakPoints.minBp('tablet')} {
        margin: ${({ theme }) => theme.spacing(32, 'auto')};
      }
    }
  }

  & .slide {
    position: absolute;
    width: 100%;
  }

  .image-container {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 180px;
    ${({ theme }) => theme.breakPoints.minBp('tablet')} {
      min-height: 450px;
    }
    ${({ theme }) => theme.breakPoints.minBp('desktop')} {
      min-height: 650px;
    }
    overflow: hidden;
    text-align: center;
    background-color: ${({ theme }) => theme.colours.yellow};
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    aspect-ratio: 2/1;

    &:before {
      display: block;
      width: 100%;
      padding-top: calc((8 / 16) * 100%);
      content: '';
    }
  }
  .fs-image-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-align: center;
    background-color: ${({ theme }) => theme.colours.yellow};
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    &:before {
      display: block;
      width: 100%;
      padding-top: calc((4 / 10) * 100%);
      content: '';
    }
  }
  .background-image-obj {
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    object-fit: cover;
  }
  .front-image {
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 1;
    width: 25%;
    height: auto;
    transform: translate(-50%, 0%);

    ${({ theme }) => theme.breakPoints.minBp('tablet')} {
      width: 28%;
    }
  }

  .controls {
    position: absolute;
    right: ${({ theme }) => theme.spacing(20)};
    bottom: ${({ theme }) => theme.spacing(20)};
    z-index: 999;
    display: flex;

    ${({ theme }) => theme.breakPoints.minBp('desktop')} {
      position: absolute;
      bottom: ${({ theme }) => theme.spacing(40)};
      right: ${({ theme }) => theme.spacing(40)};
    }

    ${({ theme }) => theme.breakPoints.minBp('1440px')} {
      position: absolute;
      bottom: ${({ theme }) => theme.spacing(70)};
      right: ${({ theme }) => theme.spacing(70)};
    }

    &.controls-align-left {
      right: unset;
      left: ${({ theme }) => theme.spacing(20)};
      bottom: ${({ theme }) => theme.spacing(20)};

      ${({ theme }) => theme.breakPoints.minBp('desktop')} {
        bottom: ${({ theme }) => theme.spacing(40)};
        left: ${({ theme }) => theme.spacing(40)};
      }

      ${({ theme }) => theme.breakPoints.minBp('1440px')} {
        bottom: ${({ theme }) => theme.spacing(70)};
        left: ${({ theme }) => theme.spacing(70)};
      }
    }

    button {
      &:first-child {
        margin-right: ${({ theme }) => theme.spacing(14)};
      }
    }
  }
`;

export const CarouselContainer = styled.div`
  width: 100%;
  background-color: rgb(255, 202, 46);
`;

export default HomepageHeroCarouselComponent;